import { Pipe, PipeTransform } from '@angular/core';
import { Router } from '@angular/router';

@Pipe({
  name: 'isActiveRoute'
})
export class IsActiveRoutePipe implements PipeTransform {

  constructor(private router: Router) { }

  transform(segments: Array<string>): boolean {

    const route = '/' + segments.filter(segment => !!segment).join('/');

    return this.router.url.startsWith(route) || this.router.url.endsWith(route);
  }
}
